import { Component, EventEmitter, Input, OnInit, Output, OnChanges, OnDestroy, ViewChild, TemplateRef, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';
import { CaseModule, Module } from '../../../../shared/models/module';
import { ModulesFacade } from '../../../../abstraction/modules.facade';
import { ProvisionsFrequencyUnit } from '../../../../core/enums/provisionsFrequencyUnit';
import { CustomValidators } from '../../../../core/validators/custom-validators';
import { catchError, map, Observable, of, Subscription, take } from 'rxjs';
import { Arrangement } from 'src/app/shared/models/arrangement';
import { ArrangementsFacade } from 'src/app/abstraction/arrangements.facade';
import { CaseModulePostQPS, modulesGetQPS } from 'src/app/shared/models/modulesQPS';
import { ModulePracticeSelected, ModuleSupplySelected } from 'src/app/modules/cases/components/modules-scheme/modules-scheme.component';
import { Practice } from 'src/app/shared/models/practice';
import { Provision } from 'src/app/shared/models/provision';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { isGuardiaLikeRestriction, isPatientPracticeRestriction } from 'src/app/core/utils/practice-restriction.utils';
import { ProvisionsUnit } from 'src/app/core/enums/provisionsUnit';
import { NomenclatorFacade } from 'src/app/abstraction/nomenclator.facade';
import { PracticesQPS } from 'src/app/core/services/nomenclator.service';
import { EntitiesFacade } from 'src/app/abstraction/entities.facade';
import { Provider } from 'src/app/shared/models/provider';
import { ModuleArrangement } from 'src/app/core/services/arrangements.service';
import { pid } from 'process';
import { ExperienceI18nService } from 'src/app/core/experience/experience-i18n.service';
import { CasesFacade } from 'src/app/abstraction/cases.facade';

@Component({
    selector: 'app-admissions-modules',
    templateUrl: './admissions-modules.component.html',
    styleUrls: ['./admissions-modules.component.scss']
})
export class AdmissionsModulesComponent implements OnInit, OnChanges, OnDestroy {

    @ViewChild('practicesPickerTemplate', { static: true }) practicesPickerTemplate: TemplateRef<any>;
    @ViewChild('suppliesPickerTemplate', { static: true }) suppliesPickerTemplate: TemplateRef<any>;

    public readonly MODULE = 'moduleId';
    public readonly MODULE_SEARCHING = 'moduleSearching';
    public readonly AMOUNT = 'amount';
    public readonly UNIT = 'unit';
    public readonly FROM_DATE = 'fromDate';
    public readonly TO_DATE = 'toDate';
    // public readonly ARRANGEMENT = 'arrangement';
    // public readonly ARRANGEMENT_SEARCHING = 'arrangementSearching';
    public readonly PROVISION_FREQUENCY_UNIT_DEFAULT = ProvisionsFrequencyUnit.DIA;

    @Input() screenCalling: string = 'ADMISSIONS';
    @Input() modulesItemsPreselected: CaseModulePostQPS[];
    @Input() financierId: number;
    @Input() arrangementSelected: Arrangement;
    @Input() modulesArrangement:ModuleArrangement[];
    @Output() modulesData = new EventEmitter<CaseModulePostQPS[]>();
    @Output() formModulesDataValid = new EventEmitter<boolean>();

    practicesPanelExpanded = true;
    suppliesPanelExpanded = true;
    practicesPickerForm: FormGroup;
    modulePracticesSelected: ModulePracticeSelected[] = [];
    modulePracticesSelectedByIndex: Map<number, ModulePracticeSelected[]> = new Map();
    moduleSuppliesSelectedByIndex: Map<number, ModuleSupplySelected[]> = new Map();
    private currentPickerModuleIndex: number = 0;
    practicesPickerSearchControl = new FormControl('');
    filteredPracticePickerRowVM: Array<{ index: number; fg: FormGroup }> = [];
    private lockedPracticePrevByIdForPicker = new Map<number, ModulePracticeSelected>();
    private lockedPracticeIdsForPicker = new Set<number>();
    private existingSupplyIdsForPicker = new Set<number>();
    btn_addModule_disabled: boolean = false;
    lastModuleData: CaseModulePostQPS[] = [];
    modules: Module[];
    modulesFiltered: Module[];
    modulesFilteredByFinancierId: Module[];
    // arrangements: Arrangement[];
    activeArrangements: Arrangement[];
    practicesToShow: Practice[];
    private _practicesDialogRef: any;
    private practicesPickerSearchSub?: Subscription;
    practices: Practice[];
    provisions: Provision[]
    private lastModuleSnapshot = '';
    supplyPickerDisplayedColumns: string[] = ['selected', 'supply', 'provider', 'quantity', 'unit', 'unitCost'];
    practicePickerDisplayedColumns: string[] = ['selected', 'practice', 'frequency', 'attentions'];

    arrangements: Arrangement[];
    public provisionsUnitOptions: {id: string, name: string} [];
    frequencyUnit: { id: string; name: string } [];

    isLoadingGettingModules: boolean;
    _isLoadingGettingModules: Subscription;
    arrangementForm: FormGroup;
    _arrangements: Subscription;
    moduleSelected: Module;
    modulesForm: FormGroup;
    _modules: Subscription;
    //arrangementSelected: Arrangement;
    suppliesPickerSearchControl = new FormControl('');
    private suppliesPickerSearchSub?: Subscription;
    suppliesPickerForm: FormGroup;
    filteredSuppliesPickerRowVM: Array<{ index: number; fg: FormGroup }> = [];
    private _suppliesDialogRef: any;
    suppliesPickerDialogTitle: string = '';
    moduleSuppliesSelected: ModuleSupplySelected[] = [];
    supplyPickerProvidersOnSelect: (Provider | null)[][] = [[]];
    supplyPickerDefaultProviders: (string | null)[] = [null];
    suppliesPickerEditMode: boolean = false;
    getmodulesQPS: modulesGetQPS = {
        active: true,
        financierId: null,
        composeItems: true,
    }
    private lastModulesQuerySnapshot = '';
    alertService: any;


    get practicesPickerRowsFA(): FormArray {
        return this.practicesPickerForm?.get('practiceRows') as FormArray;
    }

    get suppliesPickerRowsFA(): FormArray {
        return this.suppliesPickerForm?.get('supplyRows') as FormArray;
    }

    public get moduleS(): FormArray {
        return this.modulesForm.get("moduleS") as FormArray
    }


    constructor(
        private fb: FormBuilder,
        private modulesFacade: ModulesFacade,
        private arrangementsFacade: ArrangementsFacade,
        public dialog: MatDialog,
        private entitiesFacade: EntitiesFacade,
        private nomenclatorFacade: NomenclatorFacade,
        private casesFacade: CasesFacade,
        private experienceI18n: ExperienceI18nService
    ) { }

    ngOnInit(): void {

        // this._modules = this.modulesFacade.getModules$().subscribe(modules => {
        //     this.modules = modules;
        //     this.modulesFiltered = this.modules;
        // })
        // this.getmodulesQPS.financierId = this.financierId;
        // this._modules = this.modulesFacade.loadModuleByCode$(this.getmodulesQPS)
        //         .subscribe(async (moduleToUpdate) =>
        //              {this.modules  = moduleToUpdate.data })

        this._arrangements = this.arrangementsFacade.getArrangements$().subscribe(arrangements => {
            this.arrangements = arrangements;
            this.activeArrangements = arrangements?.filter(arr => !!arr.active);
        })

        // this.arrangementForm = this.createArrangementForm();

        this.modulesForm = this.fb.group({
            moduleS: this.fb.array([])
        });

        // MODULES
        this.modulesForm.statusChanges.subscribe(formModules => {
            this.btn_addModule_disabled = formModules === 'INVALID' ? true : false;
        })

        this.modulesForm.valueChanges.subscribe(() => {
            this.emitModulesData();
        });

        this.addModule();

        this.provisionsUnitOptions = [
            { id: ProvisionsUnit.UNIDAD, name: this.experienceI18n.translate('modules.admissions-modules.provisions-units.unidad', undefined, 'Unidad') },
            { id: ProvisionsUnit.BOLSA_BOLSON, name: this.experienceI18n.translate('modules.admissions-modules.provisions-units.bolsa-bolson', undefined, 'Bolsa/Bolsón') },
            { id: ProvisionsUnit.PAQUETE, name: this.experienceI18n.translate('modules.admissions-modules.provisions-units.paquete', undefined, 'Paquete') },
            { id: ProvisionsUnit.CAJA, name: this.experienceI18n.translate('modules.admissions-modules.provisions-units.caja', undefined, 'Caja') },
        ];

        this.frequencyUnit = [
            {
                id: ProvisionsFrequencyUnit.DIA,
                name: this.experienceI18n.translate('modules.admissions-modules.frequency-units.dia', undefined, 'Dia'),
            },
            {
                id: ProvisionsFrequencyUnit.SEMANA,
                name: this.experienceI18n.translate('modules.admissions-modules.frequency-units.semana', undefined, 'Semana'),
            },
            {
                id: ProvisionsFrequencyUnit.MES,
                name: this.experienceI18n.translate('modules.admissions-modules.frequency-units.mes', undefined, 'Mes'),
            },
        ];

        this.practicesPickerDialogTitle = this.experienceI18n.translate(
            'modules.admissions-modules.cargar-practicas',
            undefined,
            'Cargar prácticas'
        );

        this.suppliesPickerDialogTitle = this.experienceI18n.translate(
            'modules.admissions-modules.cargar-insumos',
            undefined,
            'Cargar insumos'
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!this.modulesItemsPreselected && this.modulesItemsPreselected.length > 0) {

            if (!this.modulesForm) {
                return;
            }

            while (this.moduleS.length !== 0) {
                this.moduleS.removeAt(0);
            }

            this.modulesItemsPreselected.forEach(modItem => {
                const moduleGroup = this.newModule();

                // FIXME: FER
                // moduleGroup.patchValue({
                //     [this.MODULE]: modItem.moduleId,
                //     [this.AMOUNT]: modItem.frequency?.amount,
                //     [this.UNIT]: modItem.frequency?.unit,
                //     [this.FROM_DATE]: moment(modItem?.fromDate),
                //     [this.TO_DATE]: moment(modItem?.toDate),
                // });

                this.moduleS.push(moduleGroup);
            });
        }
        if (changes['financierId'] && !changes['financierId'].firstChange && !!this.financierId) {
            this.getModules();
        }

        if (changes['modulesArrangement']) {
            this.refreshModulesFiltered();
            this.getModules();
        }

        if (changes['arrangementSelected']) {
            if (!!this.arrangementSelected) {
                this.onSelectArrangement();
            }
        }
    }

    getModules(){
        if(this.financierId === null || this.financierId === undefined) return;
        this.getmodulesQPS.financierId = this.financierId;
        const ids = this.getModulesArrangementIds();
        if (ids.length > 0) {
            this.getmodulesQPS.ids = ids;
        } else {
            delete this.getmodulesQPS.ids;
        }
        this.getmodulesQPS.active = true;

        const querySnapshot = this.buildModulesQuerySnapshot();
        if (querySnapshot === this.lastModulesQuerySnapshot && (this.modulesFilteredByFinancierId?.length ?? 0) > 0) {
            this.refreshModulesFiltered();
            return;
        }

        this.lastModulesQuerySnapshot = querySnapshot;

        this._modules?.unsubscribe();
        this._modules = this.modulesFacade.loadModuleByCode$(this.getmodulesQPS)
            .subscribe(async (moduleToUpdate) => {
                this.modulesFilteredByFinancierId = moduleToUpdate.data;
                this.modules = moduleToUpdate.data;
                this.refreshModulesFiltered();
            })
    }

    private buildModulesQuerySnapshot(): string {
        const ids = this.getModulesArrangementIds().slice().sort((a, b) => a - b);
        return JSON.stringify({
            financierId: this.financierId ?? null,
            ids,
            active: true,
            composeItems: true,
        });
    }

    private getModulesBaseList(): Module[] {
        return this.modulesFilteredByFinancierId ?? this.modules ?? [];
    }

    private getArrangementModuleIds(arrangementInput: Arrangement | null | undefined): number[] {
        if (!arrangementInput) {
            return [];
        }

        const arrangement = this.arrangements?.find(arr => arr.id == arrangementInput.id);
        if (!arrangement) {
            return [];
        }

        if (!!arrangement.arrangementId && (!arrangement.moduleArrangements || arrangement.moduleArrangements.length == 0)) {
            const arrangementRelated = this.arrangements?.find(arr => arr.id == arrangement.arrangementId);
            return Array.from(
                new Set(
                    (arrangementRelated?.moduleArrangements ?? [])
                        .filter(arrDetail => arrDetail.active)
                        .map(arrDetail => arrDetail.moduleId)
                )
            );
        }

        return Array.from(
            new Set(
                (arrangement.moduleArrangements ?? [])
                    .filter(arrDetail => arrDetail.active)
                    .map(arrDetail => arrDetail.moduleId)
            )
        );
    }

    private refreshModulesFiltered(): void {
        const baseModules = this.getModulesBaseList();

        if (!baseModules.length) {
            this.modulesFiltered = [];
            return;
        }

        if (this.arrangementSelected) {
            const modulesIds = this.getArrangementModuleIds(this.arrangementSelected);
            this.modulesFiltered = modulesIds.length > 0
                ? [...baseModules.filter(module => modulesIds.includes(module.id))]
                : [];
            return;
        }

        if (this.modulesArrangement?.length > 0) {
            const modulesIds = this.getModulesArrangementIds();
            this.modulesFiltered = modulesIds.length > 0
                ? [...baseModules.filter(module => modulesIds.includes(module.id))]
                : [];
            return;
        }

        this.modulesFiltered = [...baseModules];
    }

    getModulesArrangementIds(){
        return this.modulesArrangement?.map(ma => ma.moduleId) ?? [];
    }



    // createArrangementForm() {
    //     return this.fb.group({
    //         [this.ARRANGEMENT]: [],
    //         [this.ARRANGEMENT_SEARCHING]: [],
    //     })
    // }

    newModule(): FormGroup {
        return this.fb.group({
            [this.MODULE]: ['', [CustomValidators.required(this.experienceI18n.translate('modules.admissions-modules.validators.modulo-requerido', undefined, 'Módulo requerido'))]],
            [this.MODULE_SEARCHING]: [''],
            [this.AMOUNT]: ['', [CustomValidators.number(this.experienceI18n.translate('modules.admissions-modules.validators.valor-incorrecto', undefined, 'Valor incorrecto'))]],
            [this.UNIT]: [''],
            [this.FROM_DATE]: ['', [CustomValidators.required('Fecha requerida')]],
            [this.TO_DATE]: ['', [CustomValidators.required('Fecha requerida')]]
        })
    }

    private emitModulesData(): void {
        const requisitionModules: CaseModule[] = [];
        this.modulesForm.value.moduleS.forEach((moduleFormValue: any, index: number) => {
            const frequency = {
                amount: moduleFormValue['amount'] ?? null,
                unit: moduleFormValue['unit'] ?? null,
            };
            const fromDate = moduleFormValue['fromDate'] ? new Date(moduleFormValue['fromDate']) : null;
            const toDate = moduleFormValue['toDate'] ? new Date(moduleFormValue['toDate']) : null;
            const moduleId = moduleFormValue['moduleId'];

            // Catálogo del módulo seleccionado en esta fila (para resolver moduleItemId)
            const moduleCatalog = (this.modulesFiltered ?? this.modules ?? []).find(m => m.id == moduleId);
            const catalogItems = moduleCatalog?.moduleItems ?? [];
            const resolveModuleItemIdForPractice = (practiceId: number): number | null => {
                const found = catalogItems.find(i => !i.isSupply && i.practiceId === practiceId);
                const id = Number(found?.id);
                return Number.isFinite(id) && id > 0 ? id : null;
            };
            const resolveModuleItemIdForSupply = (practiceId: number): number | null => {
                const found = catalogItems.find(i => i.isSupply && i.practiceId === practiceId);
                const id = Number(found?.id);
                return Number.isFinite(id) && id > 0 ? id : null;
            };

            const practiceItems = (this.modulePracticesSelectedByIndex.get(index) ?? []).map(p => ({
                moduleItemId: resolveModuleItemIdForPractice(p.practiceId),
                practiceId: p.practiceId,
                frequency: {
                    amount: p.frequencyAmount,
                    unit: p.frequencyUnit,
                    ...(p.restrictionRequiredTime ?? this.isGuardiaLikeForPracticeId(p.practiceId)
                        ? { allowedHours: this.toFiniteOrNull(p.allowedHours) }
                        : {}),
                },
            }));
            const supplyItems = (this.moduleSuppliesSelectedByIndex.get(index) ?? []).map(s => ({
                moduleItemId: resolveModuleItemIdForSupply(s.practiceId),
                medicalSupply: {
                    provision: {
                        practiceId: s.practiceId,
                        frequency: {
                            amount: Number(s.quantity) || 0,
                            unit: String(s.unit ?? ProvisionsUnit.UNIDAD),
                        },
                        ...(s.unitCost != null ? { fee: Number(s.unitCost) || 0 } : {}),
                    },
                    agreement: s.providerId != null
                        ? {
                            providerFee: Number(s.unitCost) || 0,
                            providerId: s.providerId,
                            fromDate,
                            toDate,
                        }
                        : null,
                },
            })) as any;

            const hasModuleSelected = moduleId != null && moduleId !== '';
            const hasModuleItems = (practiceItems?.length ?? 0) > 0 || (supplyItems?.length ?? 0) > 0;
            const arrangementId = this.arrangementSelected?.id;
            // A selected module only becomes relevant when it has at least one practice or supply.
            if (hasModuleSelected || hasModuleItems) {
                requisitionModules.push({
                    moduleId,
                    frequency,
                    arrangementId,
                    fromDate,
                    toDate,
                    practiceItems,
                    supplyItems,
                });
            }
        });

        const snapshot = JSON.stringify(requisitionModules);
        if (snapshot !== this.lastModuleSnapshot) {
            this.lastModuleSnapshot = snapshot;
            this.lastModuleData = requisitionModules;
            this.modulesData.emit(requisitionModules);
        }

        const hasAnyRequisitionItems = requisitionModules.some(
            m => (m.practiceItems?.length ?? 0) > 0 || (m.supplyItems?.length ?? 0) > 0);

        const hasAnyModuleSelection = requisitionModules.some(m => m.moduleId != null);

        // Module validity requires a real selection, at least one item, and a valid form state.
        this.formModulesDataValid.emit(hasAnyModuleSelection && hasAnyRequisitionItems && this.modulesForm.status === 'VALID');
    }

    addModule() {
        this.moduleS.push(this.newModule());
    }

    removeModule(i: number) {
        if (this.moduleS['controls'].length == 1) {
            this.moduleS.removeAt(i);
            this.modulePracticesSelectedByIndex.clear();
            this.moduleSuppliesSelectedByIndex.clear();
            this.moduleS.push(this.newModule());
            this.emitModulesData();
        } else {
            this.moduleS.removeAt(i);
            // Re-indexar: desplazar entradas con key > i
            const newPracticesMap = new Map<number, ModulePracticeSelected[]>();
            const newSuppliesMap = new Map<number, ModuleSupplySelected[]>();
            for (const [key, val] of this.modulePracticesSelectedByIndex) {
                if (key < i) newPracticesMap.set(key, val);
                else if (key > i) newPracticesMap.set(key - 1, val);
            }
            for (const [key, val] of this.moduleSuppliesSelectedByIndex) {
                if (key < i) newSuppliesMap.set(key, val);
                else if (key > i) newSuppliesMap.set(key - 1, val);
            }
            this.modulePracticesSelectedByIndex = newPracticesMap;
            this.moduleSuppliesSelectedByIndex = newSuppliesMap;
            this.emitModulesData();
        }
    }

    calculateIdModule(element: Module) {
        return element ? element.id : null;
    }

    // It's necessary arrow function
    calculateNameModule = (element: Module) => {
        return element ? element.name + ' #' + element.code : null;
    }

    calculateIdArrangement(element: Arrangement) {
        return element ? element.id : null;
    }

    calculateNameArrangement(element: Arrangement) {
        return element ? element.name : null;
    }

    onSelectModule(moduleId: number, index: number) {
        this.moduleSelected = this.modulesFiltered?.find(m => m.id == moduleId);

        const row = this.getModuleSFormGroup(index);
        row?.markAllAsTouched();
        row?.updateValueAndValidity({ emitEvent: false });
    }


    ngOnDestroy(): void {
        this._modules?.unsubscribe();
        this._arrangements?.unsubscribe();
        this._isLoadingGettingModules?.unsubscribe();
        this.practicesPickerSearchSub?.unsubscribe();
        this.suppliesPickerSearchSub?.unsubscribe();
    }

    onSelectArrangement(){
        if (this.arrangementSelected) {
            const arrangement = this.arrangements?.find(arr => arr.id == this.arrangementSelected.id);
            if (arrangement) {
                this.arrangementSelected = arrangement;
                this.refreshModulesFiltered();
                return;
            }
        }

        this.alertService?.openInfo(this.experienceI18n.translate('modules.admissions-modules.el-convenio-no-incluye-uno-o-mas-de-los-modulos', undefined, 'El convenio no incluye uno o más de los módulos seleccionados. Corrija los módulos y vuelva a intentar.'));
    }

    getModuleSFormGroup(index: number): FormGroup {
        return this.moduleS.at(index) as FormGroup;
    }

    getPracticesForModule(i: number): ModulePracticeSelected[] {
        return this.modulePracticesSelectedByIndex.get(i) ?? [];
    }

    getPracticeFrequencyLabel(practice: ModulePracticeSelected): string {
        const frequency = practice.frequencyAmount && practice.frequencyUnit
            ? `${practice.frequencyAmount} por ${practice.frequencyUnit}`
            : '';
        const allowedHours = practice.allowedHours > 0
            ? `${practice.allowedHours} ${this.experienceI18n.translate(
                practice.allowedHours === 1
                    ? 'modules.admissions.admissions-modules.practice-form.frecuency.daily-hour'
                    : 'modules.admissions.admissions-modules.practice-form.frecuency.daily-hours',
                undefined,
                practice.allowedHours === 1 ? 'hora diaria' : 'horas diarias'
            )}`
            : '';

        return [frequency, allowedHours].filter(Boolean).join(' - ') || '-';
    }

    getSuppliesForModule(i: number): ModuleSupplySelected[] {
        return this.moduleSuppliesSelectedByIndex.get(i) ?? [];
    }

    togglePracticesPanel(): void {
        this.practicesPanelExpanded = !this.practicesPanelExpanded;
    }

    toggleSuppliesPanel(): void {
        this.suppliesPanelExpanded = !this.suppliesPanelExpanded;
    }


    practicesPickerDialogTitle: string = '';

    openPracticesPickerDialog(moduleIndex: number): void {
        if (!this.moduleSelected) return;

        this.currentPickerModuleIndex = moduleIndex;
        this.modulePracticesSelected = this.modulePracticesSelectedByIndex.get(moduleIndex) ?? [];

        const practiceNameById = new Map<number, string>();
        const restrictionIdByPracticeId = new Map<number, number>();
        for (const moduleItem of (this.moduleSelected?.moduleItems ?? [])) {
            if ((moduleItem as any)?.isSupply) continue;
            const practiceId = moduleItem?.practiceId
            const practiceName = moduleItem?.practiceName ?? '';
            const restrictionId = moduleItem?.restrictionId;
            if (practiceId > 0) {
                if (practiceName) practiceNameById.set(practiceId, practiceName);
                if (!!restrictionId) restrictionIdByPracticeId.set(practiceId, restrictionId);
            }
        }

        const modulePracticeIds = Array.from(
            new Set(
                (this.moduleSelected?.moduleItems ?? [])
                    .filter(i => !i.isSupply)
                    .map(i => i.practiceId)
                    .filter((id): id is number => Number.isFinite(Number(id)) && Number(id) > 0)
            )
        );


        const buildSourcePractices = (modulePracticesById: Practice[]): Practice[] => {
            return modulePracticeIds.length
                ? modulePracticeIds.map(id => {
                    const found = modulePracticesById.find(p => p.id === id);
                    const fallbackName = practiceNameById.get(id);
                    const restrictionId = restrictionIdByPracticeId.get(id) ?? found?.restriction?.id;
                    if (found) {
                        // If the cached entity doesn't have a name yet, use moduleItems.practiceName.
                        // Also propagate restrictionId from moduleItems
                        const updates: any = { restrictionId };
                        if ((!found.name || !String(found.name).trim()) && fallbackName) {
                            updates.name = fallbackName;
                        }
                        return { ...found, ...updates };
                    }
                    return { id, name: fallbackName ?? `${this.experienceI18n.translate('modules.admissions-modules.practica', undefined, 'Práctica')} ${id}`, code: String(id), restrictionId } as any;
                })
                : (this.practicesToShow ?? this.practices ?? []);
        };

        const openDialog = (sourcePractices: Practice[]) => {
            // Única fuente de verdad (evita duplicar FormArray + subs)
            this.buildPracticesPickerForm(sourcePractices);

            this._practicesDialogRef = this.dialog.open(DialogComponent, {
                disableClose: true,
                width: '80%',
                maxHeight: '95vh',
                panelClass: 'practices-picker-dialog',
                data: { template: this.practicesPickerTemplate, title: this.practicesPickerDialogTitle },
            });
        };

        const qps: PracticesQPS = { ids: modulePracticeIds };
        this.nomenclatorFacade.getOrLoadPractices$(qps).pipe(take(1)).subscribe(practices => {
            openDialog(buildSourcePractices(practices ?? []));
        });
    }

    private buildPracticesPickerForm(sourcePractices: Practice[]): void {
        const selectedById = new Map<number, ModulePracticeSelected>();
        for (const p of this.modulePracticesSelected ?? []) selectedById.set(p.practiceId, p);

        this.practicesPickerForm = this.fb.group({ practiceRows: this.fb.array([]), });
        for (const pr of sourcePractices) {
            const lockedPrev = this.lockedPracticePrevByIdForPicker.get(pr.id);
            const isLocked = this.lockedPracticeIdsForPicker.has(pr.id);
            const prev = lockedPrev ?? selectedById.get(pr.id);
            this.practicesPickerRowsFA.push(this.createPracticePickerRow(pr, prev, isLocked));
        }

        this.practicesPickerSearchControl.setValue('');

        this.practicesPickerSearchSub?.unsubscribe();
        this.practicesPickerSearchSub = this.practicesPickerSearchControl.valueChanges.subscribe(() => {
            this.refreshPracticePickerFilter();
        });
        this.refreshPracticePickerFilter();
    }

    private createPracticePickerRow(pr: Practice, prev?: ModulePracticeSelected, locked: boolean = false): FormGroup {
        const restrictionId = (pr as any)?.restrictionId ?? pr.restriction?.id ?? prev?.restrictionId ?? null;
        const restrictionRequiredTime = !!pr.restriction?.requiredTime;
        // Resolve default frequency from the module catalog item
        const catalogItem = (this.moduleSelected?.moduleItems ?? []).find(i => !i.isSupply && i.practiceId === pr.id);
        const row = this.fb.group(
            {
                selected: [locked ? true : !!prev],
                practiceId: [pr.id],
                code: [pr.code ?? ''],
                name: [pr.name ?? ''],

                frequencyAmount: [prev?.frequencyAmount ?? catalogItem?.frequencyAmount ?? null],
                frequencyUnit: [prev?.frequencyUnit ?? catalogItem?.frequencyUnit ?? null],

                minAttentions: [prev?.minAttentions ?? null],
                maxAttentions: [prev?.maxAttentions ?? null],

                allowedHours: [prev?.allowedHours ?? catalogItem?.allowedHours ?? null],
                restrictionId: [restrictionId],
                restrictionRequiredTime: [prev?.restrictionRequiredTime ?? restrictionRequiredTime],
                restrictionPatient: [prev?.restrictionPatient ?? isPatientPracticeRestriction(pr.restriction)],
            },
            { validators: [this.minMaxValidator('minAttentions', 'maxAttentions')] }
        );

        if (locked) {
            // Quedan checked y no editables
            row.get('selected')?.setValue(true, { emitEvent: false });
            // Evitamos que validaciones de min/max bloqueen el submit del picker
            row.clearValidators();
            row.updateValueAndValidity({ emitEvent: false });

            // Deshabilita campos editables
            this.setPracticeRowEnabledState(row, false);
            // No queremos que el usuario pueda deschequear
            this.setControlEnabled(row.get('selected'), false);
            return row;
        }

        this.setPracticeRowValidators(row, !!prev);

        // minAttentions y maxAttentions siempre deshabilitados
        row.get('minAttentions')?.disable({ emitEvent: false });
        row.get('maxAttentions')?.disable({ emitEvent: false });

        row.get('selected')?.valueChanges.subscribe((isSel: boolean) => {
            this.setPracticeRowValidators(row, !!isSel);
            if (isSel) {
                this.markPracticeRowInvalidControlsAsTouched(row);
            }
        });

        return row;
    }

    private minMaxValidator(minKey: string, maxKey: string, message = this.experienceI18n.translate('modules.admissions-modules.validators.el-maximo-debe-ser-mayor-o-igual', undefined, 'El máximo debe ser mayor o igual al mínimo')): ValidatorFn {
        return (control: AbstractControl) => {
            const minCtrl = control.get(minKey);
            const maxCtrl = control.get(maxKey);
            const minRaw = minCtrl?.value;
            const maxRaw = maxCtrl?.value;

            // Si alguno está vacío, no validamos relación
            if (minRaw == null || maxRaw == null || minRaw === '' || maxRaw === '') return null;

            const min = Number(minRaw);
            const max = Number(maxRaw);

            if (!Number.isFinite(min) || !Number.isFinite(max)) return null;
            return max >= min ? null : { minMax: message };
        };
    }

    private refreshPracticePickerFilter(): void {
        const q = String(this.practicesPickerSearchControl?.value ?? '').trim().toLowerCase();
        const rows = (this.practicesPickerRowsFA?.controls ?? []) as FormGroup[];
        const vm = rows.map((fg, index) => ({ fg, index }));

        this.filteredPracticePickerRowVM = !q
            ? vm
            : vm.filter(r => {
                const code = String(r.fg.get('code')?.value ?? '').toLowerCase();
                const name = String(r.fg.get('name')?.value ?? '').toLowerCase();
                return code.includes(q) || name.includes(q);
            });
    }

    private refreshSuppliesPickerFilter(): void {
        const q = String(this.suppliesPickerSearchControl?.value ?? '').trim().toLowerCase();
        const rows = (this.suppliesPickerRowsFA?.controls ?? []) as FormGroup[];
        const vm = rows.map((fg, index) => ({ fg, index }));

        this.filteredSuppliesPickerRowVM = !q
            ? vm
            : vm.filter(r => {
                const code = String(r.fg.get('code')?.value ?? '').toLowerCase();
                const name = String(r.fg.get('name')?.value ?? '').toLowerCase();
                return code.includes(q) || name.includes(q);
            });
    }

    private setPracticeRowEnabledState(row: FormGroup, selected: boolean): void {
        // minAttentions y maxAttentions siempre deshabilitados
        this.setControlEnabled(row.get('minAttentions'), false);
        this.setControlEnabled(row.get('maxAttentions'), false);

        this.setControlEnabled(row.get('frequencyAmount'), selected);
        this.setControlEnabled(row.get('frequencyUnit'), selected);
        // Solo habilitar allowedHours si la práctica es tipo guardia (requiredTime)
        this.setControlEnabled(row.get('allowedHours'), selected && this.rowRequiresAllowedHours(row));
    }

    private setControlEnabled(control: AbstractControl | null | undefined, enabled: boolean): void {
        if (!control) return;
        if (enabled) {
            if (control.disabled) control.enable({ emitEvent: false });
        } else {
            if (control.enabled) control.disable({ emitEvent: false });
        }
    }

    private setPracticeRowValidators(row: FormGroup, selected: boolean): void {
        const freqAmount = row.get('frequencyAmount');
        const freqUnit = row.get('frequencyUnit');
        const minAtt = row.get('minAttentions');
        const maxAtt = row.get('maxAttentions');

        if (selected) {
            freqAmount?.setValidators([
                CustomValidators.required(this.experienceI18n.translate('modules.admissions-modules.validators.requerido', undefined, 'Requerido')),
                CustomValidators.minValue(1, this.experienceI18n.translate('modules.admissions-modules.validators.debe-estar-entre-uno-y-mil', undefined, 'Debe estar entre 1 y 1000')),
                CustomValidators.maxValue(1000, this.experienceI18n.translate('modules.admissions-modules.validators.debe-estar-entre-uno-y-mil', undefined, 'Debe estar entre 1 y 1000')),
            ]);
            freqUnit?.setValidators([CustomValidators.required(this.experienceI18n.translate('modules.admissions-modules.validators.requerido', undefined, 'Requerido'))]);
            // min/max no son requeridos; si se cargan, deben ser >= 0
            minAtt?.setValidators([Validators.min(0)]);
            maxAtt?.setValidators([Validators.min(0)]);

            if (row.get('frequencyUnit')?.value == null) {
                row.get('frequencyUnit')?.setValue(this.PROVISION_FREQUENCY_UNIT_DEFAULT, { emitEvent: false });
            }
        } else {
            freqAmount?.clearValidators();
            freqUnit?.clearValidators();
            minAtt?.clearValidators();
            maxAtt?.clearValidators();
        }

        freqAmount?.updateValueAndValidity({ emitEvent: false });
        freqUnit?.updateValueAndValidity({ emitEvent: false });
        minAtt?.updateValueAndValidity({ emitEvent: false });
        maxAtt?.updateValueAndValidity({ emitEvent: false });

        const allowedHours = row.get('allowedHours');
        if (selected && this.rowRequiresAllowedHours(row)) {
            allowedHours?.setValidators([
                CustomValidators.required(this.experienceI18n.translate('modules.admissions-modules.validators.requerido', undefined, 'Requerido')),
                CustomValidators.minValue(1, this.experienceI18n.translate('modules.admissions-modules.validators.debe-estar-entre-uno-y-veinticuatro', undefined, 'Debe estar entre 1 y 24')),
                CustomValidators.maxValue(24, this.experienceI18n.translate('modules.admissions-modules.validators.debe-estar-entre-uno-y-veinticuatro', undefined, 'Debe estar entre 1 y 24')),
            ]);
        } else {
            allowedHours?.clearValidators();
        }
        allowedHours?.updateValueAndValidity({ emitEvent: false });

        this.setPracticeRowEnabledState(row, selected);
        row.updateValueAndValidity({ emitEvent: false });
    }

    private markPracticeRowInvalidControlsAsTouched(row: FormGroup): void {
        const controlsToCheck = ['frequencyAmount', 'frequencyUnit'];
        if (this.rowRequiresAllowedHours(row)) {
            controlsToCheck.push('allowedHours');
        }

        for (const name of controlsToCheck) {
            const control = row.get(name);
            if (!control || control.disabled) continue;
            control.updateValueAndValidity({ emitEvent: false });
            if (control.invalid) {
                control.markAsTouched();
            }
        }
    }

    private rowRequiresAllowedHours(row: FormGroup): boolean {
        const flag = row.get('restrictionRequiredTime')?.value;
        if (flag != null && flag !== '') {
            return !!flag;
        }
        return this.isGuardiaLikeForPracticeId(Number(row.get('practiceId')?.value));
    }

    private isGuardiaLikeForPracticeId(practiceId: number): boolean {
        const practice =
            this.practices?.find((p) => p.id === practiceId) ??
            this.practicesToShow?.find((p) => p.id === practiceId);
        return isGuardiaLikeRestriction(practice?.restriction);
    }

    openSuppliesPickerDialog(moduleIndex: number): void {
        if (!this.moduleSelected) return;

        this.currentPickerModuleIndex = moduleIndex;
        this.moduleSuppliesSelected = this.moduleSuppliesSelectedByIndex.get(moduleIndex) ?? [];

        const supplyNameById = new Map<number, string>();
        for (const mi of (this.moduleSelected?.moduleItems ?? [])) {
            if (!(mi as any)?.isSupply) continue;
            const pid = Number((mi as any)?.practiceId);
            const pname = String((mi as any)?.practiceName ?? '').trim();
            if (Number.isFinite(pid) && pid > 0 && pname) {
                supplyNameById.set(pid, pname);
            }
        }

        // Fuente de opciones: items del módulo seleccionado (solo insumos)
        const moduleSupplyIds = Array.from(
            new Set(
                (this.moduleSelected?.moduleItems ?? [])
                    .filter(i => i.isSupply)
                    .map(i => i.practiceId)
                    .filter((id): id is number => Number.isFinite(Number(id)) && Number(id) > 0)
            )
        );

        const supplyById = new Map<number, Practice>();
        for (const p of this.practicesToShow ?? []) supplyById.set(p.id, p);
        for (const p of this.practices ?? []) supplyById.set(p.id, p);
        for (const prov of this.provisions ?? []) {
            const pr = (prov as any)?.practice as Practice | undefined;
            if (pr?.id != null) supplyById.set(pr.id, pr);
        }

        const sourceSupplies: Practice[] = moduleSupplyIds.length
            ? moduleSupplyIds.map(id => {
                const found = supplyById.get(id);
                const fallbackName = supplyNameById.get(id);
                if (found) {
                    if ((!found.name || !String(found.name).trim()) && fallbackName) {
                        return { ...found, name: fallbackName };
                    }
                    return found;
                }
                return { id, name: fallbackName ?? `${this.experienceI18n.translate('modules.admissions-modules.insumo', undefined, 'Insumo')} ${id}`, code: String(id) };
            })
            : [];

        // Única fuente de verdad (evita duplicar FormArray + subs)
        this.buildSuppliesPickerForm(sourceSupplies);

        this._suppliesDialogRef = this.dialog.open(DialogComponent, {
            disableClose: true,
            minWidth: '85%',
            maxHeight: '95vh',
            panelClass: 'supplies-picker-dialog',
            data: { template: this.suppliesPickerTemplate, title: this.suppliesPickerDialogTitle },
        });
    }

    private buildSuppliesPickerForm(sourceSupplies: Practice[]): void {
        // Mapa por provisionFeeId (clave única) cuando existe, fallback a practiceId
        const selectedByKey = new Map<string, ModuleSupplySelected>();
        for (const s of this.moduleSuppliesSelected ?? []) {
            // Usar provisionFeeId si existe, sino practiceId como fallback
            const key = s.provisionFeeId != null ? `pf_${s.provisionFeeId}` : `pr_${s.practiceId}`;
            selectedByKey.set(key, s);
        }

        this.suppliesPickerForm = this.fb.group({
            supplyRows: this.fb.array([]),
        });

        // Resetear arrays de providers
        this.supplyPickerProvidersOnSelect = [];
        this.supplyPickerDefaultProviders = [];

        // Si estamos en modo edición y hay moduleSuppliesSelected con provisionFeeId,
        // usamos esos directamente en vez de sourceSupplies (del catálogo)
        const useModuleSuppliesAsSource = this.suppliesPickerEditMode &&
            (this.moduleSuppliesSelected ?? []).some(s => s.provisionFeeId != null);

        if (useModuleSuppliesAsSource) {
            // En modo edición con provisionFeeId, cada item de moduleSuppliesSelected es una fila
            let idx = 0;
            for (const modSup of this.moduleSuppliesSelected ?? []) {
                // Crear un Practice falso para la fila
                const fakePractice: Practice = {
                    id: modSup.practiceId,
                    code: modSup.code ?? '',
                    name: modSup.name ?? '',
                } as Practice;

                // Popular arrays de providers (como supply-list)
                // this.supplyPickerProvidersOnSelect[idx] = modSup.provider ? [modSup.provider] : [];
                this.supplyPickerDefaultProviders[idx] = modSup.providerId?.toString() ?? null;

                this.suppliesPickerRowsFA.push(this.createSupplyPickerRowFromSelected(fakePractice, modSup));
                idx++;
            }
        } else {
            // Modo tradicional: iterar sourceSupplies del catálogo
            let idx = 0;
            for (const sup of sourceSupplies) {
                const prev = selectedByKey.get(`pr_${sup.id}`);

                // Popular arrays de providers
                // this.supplyPickerProvidersOnSelect[idx] = prev?.provider ? [prev.provider] : [];
                this.supplyPickerDefaultProviders[idx] = prev?.providerId?.toString() ?? null;

                this.suppliesPickerRowsFA.push(this.createSupplyPickerRow(sup, prev));
                idx++;
            }
        }

        this.suppliesPickerSearchControl.setValue('');

        this.suppliesPickerSearchSub?.unsubscribe();
        this.suppliesPickerSearchSub = this.suppliesPickerSearchControl.valueChanges.subscribe(() => {
            this.refreshSuppliesPickerFilter();
        });
        this.refreshSuppliesPickerFilter();
    }

    private createSupplyPickerRow(sup: Practice, prev?: ModuleSupplySelected): FormGroup {
        const row = this.fb.group({
            selected: [!!prev],
            practiceId: [sup.id],
            provisionFeeId: [prev?.provisionFeeId ?? null],
            code: [sup.code ?? ''],
            name: [sup.name ?? ''],
            caseModuleId: null,
            providerId: [prev?.providerId ?? null],
            providerSearching: [prev?.providerName ?? ''], // Mostrar nombre del proveedor en el autocomplete
            providerName: [prev?.providerName ?? null],
            quantity: [prev?.quantity ?? null],
            unit: [prev?.unit ?? null],
            unitCost: [prev?.unitCost ?? null],
        });

        this.setSupplyRowValidators(row, !!prev);

        row.get('selected')?.valueChanges.subscribe((isSel: boolean) => {
            this.setSupplyRowValidators(row, !!isSel);
        });

        return row;
    }

    /**
     * Crea una fila del picker desde un ModuleSupplySelected (modo edición con provisionFeeId).
     * La fila viene pre-seleccionada y con todos los datos ya cargados.
     */
    private createSupplyPickerRowFromSelected(sup: Practice, modSup: ModuleSupplySelected): FormGroup {
        const row = this.fb.group({
            selected: [true], // En modo edición filtrado, todos vienen seleccionados
            practiceId: [modSup.practiceId],
            provisionFeeId: [modSup.provisionFeeId ?? null],
            code: [modSup.code ?? sup.code ?? ''],
            name: [modSup.name ?? sup.name ?? ''],
            caseModuleId: null,
            providerId: [modSup.providerId ?? null],
            providerSearching: [modSup.providerName ?? ''], // Mostrar nombre del proveedor en el autocomplete
            providerName: [modSup.providerName ?? null],

            quantity: [modSup.quantity ?? null],
            unit: [modSup.unit ?? ProvisionsUnit.UNIDAD],
            unitCost: [modSup.unitCost ?? null],
        });

        this.setSupplyRowValidators(row, true);

        row.get('selected')?.valueChanges.subscribe((isSel: boolean) => {
            this.setSupplyRowValidators(row, !!isSel);
        });

        return row;
    }

    private setSupplyRowValidators(row: FormGroup, selected: boolean): void {
        const qty = row.get('quantity');
        const unit = row.get('unit');
        const unitCost = row.get('unitCost');

        if (selected) {
            qty?.setValidators([
                CustomValidators.required(this.experienceI18n.translate('modules.admissions-modules.validators.cantidad-requerida', undefined, 'Cantidad requerida')),
                CustomValidators.minValue(0, this.experienceI18n.translate('modules.admissions-modules.validators.valor-positivo', undefined, 'Debe ser un valor positivo')),
            ]);
            unit?.setValidators([CustomValidators.required(this.experienceI18n.translate('modules.admissions-modules.validators.unidad-requerida', undefined, 'Unidad requerida'))]);

            // opcional, pero si viene debe ser >=0
            unitCost?.setValidators([Validators.min(0)]);

            // if (row.get('unit')?.value == null) {
            //     row.get('unit')?.setValue(ProvisionsUnit.UNIDAD, { emitEvent: false });
            // }
        } else {
            qty?.clearValidators();
            unit?.clearValidators();
            unitCost?.clearValidators();
        }

        qty?.updateValueAndValidity({ emitEvent: false });
        unit?.updateValueAndValidity({ emitEvent: false });
        unitCost?.updateValueAndValidity({ emitEvent: false });

        this.setSupplyRowEnabledState(row, selected);
        row.updateValueAndValidity({ emitEvent: false });
    }

    private setSupplyRowEnabledState(row: FormGroup, selected: boolean): void {
        this.setControlEnabled(row.get('providerId'), selected);
        this.setControlEnabled(row.get('providerSearching'), selected);
        this.setControlEnabled(row.get('quantity'), selected);
        this.setControlEnabled(row.get('unit'), selected);
        this.setControlEnabled(row.get('unitCost'), selected);
    }

    onPracticesPickerSearch(st: string): void {
        this.practicesPickerSearchControl.setValue(st ?? '');
    }

    isAllPickerPracticesSelected(): boolean {
        const visible = this.getFilteredPracticePickerRowVM();
        return visible.length > 0 && visible.every(r => r.fg.get('selected')?.value === true);
    }

    getFilteredPracticePickerRowVM(): Array<{ index: number; fg: FormGroup }> {
        return this.filteredPracticePickerRowVM;
    }

    isSomePickerPracticesSelected(): boolean {
        const visible = this.getFilteredPracticePickerRowVM();
        const selectedCount = visible.filter(r => r.fg.get('selected')?.value === true).length;
        return selectedCount > 0 && selectedCount < visible.length;
    }

    getSelectablePickerPracticesCount(): number {
        const visible = this.getFilteredPracticePickerRowVM();
        return visible.filter(r => r.fg.get('selected')?.enabled).length;
    }

    toggleAllPickerPractices(checked: boolean): void {
        for (const r of this.getFilteredPracticePickerRowVM()) {
            const ctrl = r.fg.get('selected');
            if (ctrl?.disabled) continue;
            ctrl?.setValue(checked);
        }
    }

    isPatientSelfCarePracticePickerRow(row: { fg?: FormGroup } | null | undefined): boolean {
        const fg = row?.fg;
        if (!fg) {
            return false;
        }
        const flag = fg.get('restrictionPatient')?.value;
        if (flag != null && flag !== '') {
            return !!flag;
        }
        const practiceId = Number(fg.get('practiceId')?.value);
        if (!Number.isFinite(practiceId)) {
            return false;
        }
        const catalogPractice =
            this.practices?.find(p => p.id === practiceId) ??
            this.practicesToShow?.find(p => p.id === practiceId);
        return isPatientPracticeRestriction(catalogPractice?.restriction);
    }

    markPracticePickerControlTouched(row: FormGroup, controlName: string): void {
        const control = row?.get(controlName);
        if (!control || control.disabled) return;
        control.markAsTouched();
        control.updateValueAndValidity({ emitEvent: false });
    }

    calculateIdUnit(element) {
        return element ? element.id : null;
    }

    calculateNameUnit(element) {
        return element ? element.name : null;
    }
    isPracticePickerRowWithVisibleErrors(row: FormGroup): boolean {
        if (!row || row.get('selected')?.value !== true) return false;

        const controlsToCheck = ['frequencyAmount', 'frequencyUnit'];
        if (this.rowRequiresAllowedHours(row)) {
            controlsToCheck.push('allowedHours');
        }

        return controlsToCheck.some((name) => {
            const control = row.get(name);
            return !!control && control.enabled && control.invalid && (control.touched || control.dirty);
        });
    }

    closePracticesPickerDialog(): void {
        this._practicesDialogRef?.close();
    }

    applyPracticesPickerSelection(): void {
        if (!this.practicesPickerForm) return;
        if (this.practicesPickerForm.invalid) {
            this.practicesPickerForm.markAllAsTouched();
            return;
        }

        const rows = (this.practicesPickerRowsFA?.getRawValue?.() ?? []) as any[];
        const selected = rows.filter(r => r.selected);
        this.modulePracticesSelected = selected.map(r => ({
            practiceId: r.practiceId,
            code: r.code,
            name: r.name,
            frequencyAmount: this.toFiniteOrNull(r.frequencyAmount),
            frequencyUnit: r.frequencyUnit ?? this.PROVISION_FREQUENCY_UNIT_DEFAULT,
            allowedHours: this.toFiniteOrNull(r.allowedHours),
            restrictionId: this.toFiniteOrNull(r.restrictionId),
            restrictionRequiredTime: !!r.restrictionRequiredTime,
            restrictionPatient: !!r.restrictionPatient,
            minAttentions: this.toFiniteOrNull(r.minAttentions),
            maxAttentions: this.toFiniteOrNull(r.maxAttentions),
        }));

        this.modulePracticesSelectedByIndex.set(this.currentPickerModuleIndex, this.modulePracticesSelected);
        this.emitModulesData();
        this.closePracticesPickerDialog();
    }

    getSelectedPickerPracticesCount(): number {
        const rows = (this.practicesPickerRowsFA?.controls ?? []) as FormGroup[];
        return rows.filter(r => r.get('selected')?.value === true).length;
    }

    private toFiniteOrNull(value: any): number | null {
        const n = Number(value);
        return Number.isFinite(n) ? n : null;
    }

    onSuppliesPickerSearch(st: string): void {
        this.suppliesPickerSearchControl.setValue(st ?? '');
    }

    getSelectedPickerSuppliesCount(): number {
        const rows = (this.suppliesPickerRowsFA?.controls ?? []) as FormGroup[];
        return rows.filter(r => r.get('selected')?.value === true).length;
    }

    isAllPickerSuppliesSelected(): boolean {
        const visible = this.getFilteredSuppliesPickerRowVM();
        return visible.length > 0 && visible.every(r => r.fg.get('selected')?.value === true);
    }

    isSomePickerSuppliesSelected(): boolean {
        const visible = this.getFilteredSuppliesPickerRowVM();
        const selectedCount = visible.filter(r => r.fg.get('selected')?.value === true).length;
        return selectedCount > 0 && selectedCount < visible.length;
    }

    toggleAllPickerSupplies(checked: boolean): void {
        for (const r of this.getFilteredSuppliesPickerRowVM()) {
            r.fg.get('selected')?.setValue(checked);
        }
    }

    getFilteredSuppliesPickerRowVM(): Array<{ index: number; fg: FormGroup }> {
        return this.filteredSuppliesPickerRowVM;
    }

    isSupplyAlreadyAddedInCaseModuleForPicker(practiceId: any): boolean {
        const id = Number(practiceId);
        return Number.isFinite(id) && this.existingSupplyIdsForPicker.has(id);
    }

    getProvidersByName = (value: string): Observable<Provider[]> => {
        return this.entitiesFacade
            .loadProviders({ fullName_like: value, active: true, isSupply: true })
            .pipe(
                map((providers) => (Array.isArray(providers) ? providers : [])),
                catchError(() => of([])),
            );
    }

    calculateIdProvider = (element: Provider) => {
        return element ? element.id : null;
    }

    calculateNameProvider = (element: Provider) => {
        return element ? this.entitiesFacade.getProvidersFullName(element) : null;
    }

    onSupplyPickerProviderSelected(row: FormGroup, provider: Provider | any): void {
        if (!row) return;

        if (!provider) {
            row.get('providerId')?.setValue(null, { emitEvent: false });
            row.get('providerName')?.setValue(null, { emitEvent: false });
            return;
        }

        // Normal case: the component emits the full entity
        if (typeof provider === 'object') {
            const p = provider as Provider;
            const providerId = (p as any)?.id ?? null;
            row.get('providerId')?.setValue(providerId, { emitEvent: false });
            row.get('providerName')?.setValue(providerId != null ? this.entitiesFacade.getProvidersFullName(p) : null, { emitEvent: false });
            return;
        }

        // Fallback: if it emits an id
        const id = Number(provider);
        row.get('providerId')?.setValue(Number.isFinite(id) ? id : null, { emitEvent: false });
    }

    applySuppliesPickerSelection(): void {
        if (!this.suppliesPickerForm) return;
        if (this.suppliesPickerForm.invalid) {
            this.suppliesPickerForm.markAllAsTouched();
            return;
        }
        const rows = (this.suppliesPickerRowsFA?.getRawValue?.() ?? []) as any[];
        const selected = rows.filter(r => r.selected);
        this.moduleSuppliesSelected = selected.map(r => ({
            practiceId: r.practiceId,
            provisionFeeId: r.provisionFeeId ?? null,
            code: r.code,
            name: r.name,
            providerId: r.providerId ?? null,
            provider: null,
            providerName: r.providerName ?? null,
            quantity: this.toFiniteOrNull(r.quantity),
            unit: r.unit ?? null,
            unitCost: this.toFiniteOrNull(r.unitCost),
        }));

        this.moduleSuppliesSelectedByIndex.set(this.currentPickerModuleIndex, this.moduleSuppliesSelected);
        this.emitModulesData();
        this.closeSuppliesPickerDialog();
    }

    closeSuppliesPickerDialog(): void {
        this._suppliesDialogRef?.close();
    }

}
